import React, { useEffect, useState } from 'react';
import '../css/Settings.css';
import { Link } from 'react-router-dom';
import { enviarDuvidaCentralAtendimento } from '../firebase/atendimento';

// ICONES
import { IonIcon } from '@ionic/react';
import { wifiOutline, batteryFullOutline, cellularOutline, settings, call, closeCircleOutline, checkmarkCircleOutline, sunny, moon, logoGithub, logoJavascript, logoHtml5, logoCss3, logoFirebase, logoReact } from 'ionicons/icons';


const Settings = () => {
  
  // DADOS
  const storedResponsavel = localStorage.getItem('responsavel');
  const storedLogado = localStorage.getItem('logado');
  const storedUsuario = localStorage.getItem('usuario');  
  const [responsavel, setResponsavel] = useState(storedResponsavel ? storedResponsavel : null);
  const [logado, setLogado] = useState(storedLogado ? storedLogado.toLowerCase() : null);
  const [usuario, setUsuario] = useState(storedUsuario ? storedUsuario : null);

  if (!logado) {
    localStorage.clear();
    window.location.href = "../logar";
  }

  // RELOGIO
  const [horaAtual, setHoraAtual] = useState(new Date());

  useEffect(() => {
    
    const intervalId = setInterval(() => {
      setHoraAtual(new Date());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const formatDigit = (digit) => (digit < 10 ? '0' + digit : digit);

  const horas = formatDigit(horaAtual.getHours());
  const minutos = formatDigit(horaAtual.getMinutes());
  const segundos = formatDigit(horaAtual.getSeconds());

  const tema = localStorage.getItem('tema');
  const status = localStorage.getItem('temaStatus');
  const [mdEvento, setMdEvento] = useState(status === "off" ? false : true );
  
  // FUNÇÕES SOBRE O TEMA
  async function desativarEvento() {
    const btnAtivo = document.querySelector('.btnTemaAtivo');
    await localStorage.setItem('temaStatus', 'off');
    localStorage.setItem('tema', 'light');       
    await setMdEvento(!mdEvento);
    await window.location.reload();
  }

  async function ativarEvento() {
      const btnAtivo = document.querySelector('.btnTemaAtivo');
      await localStorage.setItem('temaStatus', 'on');
      await window.location.reload();       
      await setMdEvento(!mdEvento);
      await window.location.reload();
  }

  async function mudarTema() {
    if (tema === "light" || tema === "normal") {
       await localStorage.setItem('tema', 'dark');
    } else if (tema === "dark") {
        await localStorage.setItem('tema', 'light');
    }
    await window.location.reload();
  }

  // DÚVIDA
  const [mensagemDuvida, setMensagemDuvida] = useState('');

  return (
    <main className="container-settings">
      <div className="before">
        <p id="hora">
          {horas}:{minutos}:{segundos}
        </p>

        <div className="flex">
          <IonIcon icon={wifiOutline} />
          <IonIcon icon={cellularOutline} />
          <IonIcon icon={batteryFullOutline} />
        </div>
      </div>

      <header className="local">

        <h1>Configurações</h1>
        <Link to="/app/configuracoes">
          
        </Link>

      </header>

      <section className="content">

            <ul>

                {mdEvento ? (
                  <li className="btnTemaAtivo" onClick={() => desativarEvento()}>
                      <div className="iconsTema">
                          <IonIcon icon={closeCircleOutline} />
                      </div>
                      <h1>Desativar Tema do Evento</h1>
                      <h1 id="eventoh1"></h1>
                  </li>
                ) : (
                  <li className="btnTemaDesativado" onClick={() => ativarEvento()}>
                      <div className="iconsTema">
                          
                      <IonIcon icon={checkmarkCircleOutline} />
                      </div>
                      <h1>Ativar Tema do Evento</h1>
                      <h1 id="eventoh1"></h1>
                  </li>
                )}
                
                
                
                        
                {!mdEvento && (
                  <li id="btnTema" onClick={() => mudarTema()}>
                    <div className="iconsTema">
                        {tema === 'light' ? (
                          <IonIcon icon={sunny} />
                          ) : tema === 'dark' ? (
                          <IonIcon icon={moon} />
                        ) : tema === "normal" ? (
                          <IonIcon icon={sunny} />
                        ) : (
                          <div></div>
                        )}
                    </div>
                    <h1>Mudar tema</h1>
                    <h1 id="temah1"></h1>
                  </li>
                )}
                

                <section className="card">

                    <h1>
                        <IonIcon icon={call} />Central de Atendimento</h1>
                    <p>Achou algum erro ou está com alguma dúvida? Envie uma mensagem para nossa central de atendimento.</p>
                    
                    <div className="flex form-tecvit">
                        <div className='flex'>
                          <input onChange={(e) => setMensagemDuvida(e.target.value)} placeholder=" " value={mensagemDuvida} type="text" />     
                          <label>Escreva sua dúvida</label>
                        </div>
                        <div className='flex'>
                          {logado === 'responsavel' ? (
                              <button onClick={() => {
                                enviarDuvidaCentralAtendimento(responsavel, mensagemDuvida);
                                setMensagemDuvida('');
                              }}>Enviar</button>
                          ) : (
                            <button onClick={() => {
                              enviarDuvidaCentralAtendimento(logado, mensagemDuvida);
                              setMensagemDuvida('');
                            }}>Enviar</button>
                          )}
                        </div>
                        
                    </div>
                  
                </section>

                <section className="card">

                    <h1>Precisando de ajuda?</h1>
                    <p>Em caso de dúvidas você pode entrar em contato com a Central de Atendimento da Secretaria da escola: telefones <a href="tel:1633244623">16 3324-4623</a> ou <a href="tel:1633242256">16 3324-2256 </a> 
                    e whatsapp <a className="whats" href="https://wa.me/5516991190322">+55 16 991190322</a></p>
                
                </section>

                <section className="card">

                    <h1>Orientações de atendimento:</h1>
                    
                    <h2>Secretaria:</h2>
                    <p>Solicitação de documentos, matrículas, RA, declarações e declarações de transporte, histórico, documentos, atualização de telefone, atestados e dúvidas em geral.</p>

                    <h2>Coordenação:</h2>
                    <p>Informações sobre notas, faltas, dúvidas em relação as aulas, dificuldades pedagógicas e comportamento.</p>

                    <h2>Proatecs:</h2>
                    <p>Apoio em relação aos usos de plataformas e tecnologia.</p>

                    <h2>Direção:</h2>
                    <p>Questões disciplinares, projetos, sugestões, reclamações e orientações.</p>

                    <h2>Professores:</h2>
                    <p>Dúvidas específicas das disciplinas, dúvidas quanto ao acompanhamento dos alunos, trabalhos e provas.</p>

                    <h2>Funcionário:</h2>
                    <p>Entrada, saída, horários, organização escolar, solicitações, encaminhamentos, limpeza, zeladoria e merenda.</p>

                </section>

                <div className="flex">
                    <Link to="/security/termos">
                      <a>Termos de Uso</a>
                    </Link>
                    <span>|</span>
                    <Link to="/security/privacidade">
                      <a>Política de Privacidade</a>
                    </Link>
                </div>

            </ul>

        </section>

        <section className="creditos">

            <h1>Desenvolvido por <a href="#tecvit">TecVit</a></h1>
            <div>
                <IonIcon className="html" icon={logoHtml5} />
                <IonIcon className="css" icon={logoCss3} />
                <IonIcon className="react" icon={logoReact} />
                <IonIcon className="js" icon={logoJavascript} />
                <IonIcon className="github" icon={logoGithub} />
                <IonIcon className="firebase" icon={logoFirebase} />
            </div>

            <div className="version">
                <p>Versão do Ensino Médio 2.0.0</p>
            </div>

            <a className='cop'>© Copyright 2024 Escola Letícia - Todos os direitos reservados</a>
            
        </section>

    </main>
  );
};


export default Settings;